import React, { useState } from "react";
import SubTabBar from "../components/console_page/sub_tab_bar/SubTabBar";


/**
 * @param {*} props - router        = the sub-tab router to use
 *                  - passData      = the data to pass on
 */
function TabTemplate(props) {

  const router = props.router;
  const [subTab, setSubTab] = useState(Object.keys(router)[0]);

  // Create a clone of the provided sub-tab content, and give it the user, project, and extra data
  const clonedSubTab = React.cloneElement( router[subTab].element, {...props.passData});

  return (
    <div>
      <SubTabBar router={router} subTab={subTab} setSubTab={setSubTab} accentColour={props.passData.accentColour} />
      {clonedSubTab}
    </div>
  )

}

export default TabTemplate;